import React from 'react';

import { CustomNextImage as Image } from '@crehana/next';
import { Container, Row, Col } from '@crehana/ui/dist/GridV2';
import { useTranslation } from '@crehana/i18n';

import { InfoSectionProps } from './types';

const InfoSection: React.FC<React.PropsWithChildren<InfoSectionProps>> = ({
  title,
  image,
  description,
}) => {
  const { t } = useTranslation();

  return (
    <section className="py-80">
      <Container>
        <Row className="items-center">
          <Col
            className="text-center order-2 sm:order-1 sm:text-right"
            xs={12}
            sm={5}
          >
            <Image width={300} height={300} alt={title} src={image} />
          </Col>
          <Col className="order-1 sm:order-2" xs={12} sm={5}>
            <div className="sm:pt-64">
              <h2 className="font-h4 mb-20">{t(title)}</h2>
              <p className="font-body3">{t(description)}</p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default InfoSection;
